export default function EditPreparationItemCommentDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSavePreparationItemComment = _handleSavePreparationItemComment;

  vm.IsValidControl = _IsValidControl;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog);
  }

  function _handleSavePreparationItemComment() {
    const dfdSave = $q.defer();

    if ($scope.editAMPreparationItemNoteForm.$valid) {
      amDataService.savePreparationItemComment(
        vm.preparationItemId,
        vm.preparationItemCommentId,
        vm.preparationItemCommentText
      ).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the Preparation Item Note.');
        } else {
          alerts.success('The Preparation Item Note has been saved successfully.');
          $rootScope.$broadcast('refreshAMPreparationItemComments', { preparationItemId: vm.preparationItemId });
          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  function _IsValidControl(ctrl) {
    return ($scope.editAMPreparationItemNoteForm)
      && (($scope.editAMPreparationItemNoteForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditPreparationItemCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
